module.exports = __webpack_public_path__ + "img/industryBG.29d9cc1e.png";